@reference "~/styles.css";

@layer components {
	.hideArrow {
		:global(.ant-tooltip-arrow) {
			@apply hidden;
		}
	}
}
